export interface NavigationItem { to: string; label: string; group: string; shortcut?: string }
export function navigation(operator: boolean): NavigationItem[] {
  return operator ? [
    { to: '/', label: 'Overview', group: 'Operations', shortcut: 'o' },
    { to: '/customers', label: 'Customers', group: 'Operations' },
    { to: '/services', label: 'Services', group: 'Operations', shortcut: 's' },
    { to: '/databases', label: 'Data & storage', group: 'Operations', shortcut: 'd' },
    { to: '/deploys', label: 'Deployments', group: 'Operations' },
    { to: '/analytics', label: 'Analytics', group: 'Manage' },
    { to: '/support', label: 'Support inbox', group: 'Manage' },
    { to: '/invites', label: 'Invitations', group: 'Manage' },
    { to: '/experts', label: 'Expert reviews', group: 'Manage' },
    { to: '/audit', label: 'Audit log', group: 'Manage' },
    { to: '/account', label: 'Account', group: 'Settings', shortcut: 'a' },
  ] : [
    { to: '/', label: 'Overview', group: 'Workspace', shortcut: 'o' },
    { to: '/projects', label: 'Applications', group: 'Workspace', shortcut: 'p' },
    { to: '/services', label: 'Components', group: 'Workspace', shortcut: 's' },
    { to: '/databases', label: 'Data & storage', group: 'Workspace', shortcut: 'd' },
    { to: '/mail', label: 'Mail', group: 'Workspace', shortcut: 'm' },
    { to: '/insights', label: 'Usage & spending', group: 'Manage' },
    { to: '/protection', label: 'Backups & recovery', group: 'Manage' },
    { to: '/billing', label: 'Billing', group: 'Manage', shortcut: 'b' },
    { to: '/templates', label: 'Templates', group: 'Resources' },
    { to: '/experts', label: 'Experts', group: 'Resources' },
    { to: '/support', label: 'Support', group: 'Resources' },
    { to: '/account', label: 'Account', group: 'Settings', shortcut: 'a' },
  ]
}
export const engineName = (engine: string) => ({ postgres: 'PostgreSQL', redis: 'Redis', minio: 'Object storage', rabbitmq: 'RabbitMQ' }[engine] ?? engine)
export const customerSupportPath = (ownerId: string) => `/support-account/${encodeURIComponent(ownerId)}`
export function safeReturnPath(value: string | null | undefined): string {
  return value?.startsWith('/') && !value.startsWith('//') && !value.includes('\\') ? value : '/'
}
